import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import ScenarioList from './ScenarioList';
import ScenarioEditor from './ScenarioEditor';
export const ScenarioManager = ({ levelId, nodes, onUnsavedChangesChange, onRegisterSave }) => {
    const [currentView, setCurrentView] = useState('list');
    const [editingScenarioId, setEditingScenarioId] = useState(null);
    const handleEditScenario = (scenarioId) => {
        setEditingScenarioId(scenarioId);
        setCurrentView('editor');
    };
    const handleCreateScenario = () => {
        setEditingScenarioId(null); // null means creating a new scenario
        setCurrentView('editor');
    };
    const handleBackToList = () => {
        // Report that there are no more unsaved changes
        onUnsavedChangesChange === null || onUnsavedChangesChange === void 0 ? void 0 : onUnsavedChangesChange(false, '');
        setCurrentView('list');
        setEditingScenarioId(null);
    };
    return (_jsx(_Fragment, { children: currentView === 'list' ? (_jsx(ScenarioList, { levelId: levelId, nodes: nodes, onEditScenario: handleEditScenario, onCreateScenario: handleCreateScenario })) : (_jsx(ScenarioEditor, { levelId: levelId, scenarioId: editingScenarioId, onBack: handleBackToList, onUnsavedChangesChange: onUnsavedChangesChange, onRegisterSave: onRegisterSave })) }));
};
